/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Step_Up_TitleInputs */

const en_gb2_step_up_title = /** @type {(inputs: Step_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm it's you`)
};

const fr_step_up_title = /** @type {(inputs: Step_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmez votre identité`)
};

/**
* | output |
* | --- |
* | "Confirm it's you" |
*
* @param {Step_Up_TitleInputs} inputs
* @param {{ locale?: "en-GB" | "fr" }} options
* @returns {LocalizedString}
*/
export const step_up_title = /** @type {((inputs?: Step_Up_TitleInputs, options?: { locale?: "en-GB" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Step_Up_TitleInputs, { locale?: "en-GB" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_step_up_title(inputs)
	return en_gb2_step_up_title(inputs)
});